module.exports = __webpack_public_path__ + "static/media/benefit_3.1dcd30d3.svg";